/**
 * TransferStatusBadge.js
 *
 * Pill-style transfer status badges (matches ApprovalStatusBadge / complaints pills).
 */

import React from 'react';
import '../../../shared/components/common/Badges.css';

export const TRANSFER_STATUS_CONFIG = {
  draft: {
    label: 'Draft',
    className: 'status-transfer-draft',
  },
  pending_source_approval: {
    label: 'Awaiting source',
    className: 'status-transfer-source',
  },
  pending_destination_approval: {
    label: 'Awaiting destination',
    className: 'status-transfer-destination',
  },
  completed: {
    label: 'Completed',
    className: 'status-transfer-completed',
  },
  rejected_by_source: {
    label: 'Rejected at source',
    className: 'status-transfer-rejected',
  },
  rejected_by_destination: {
    label: 'Rejected at destination',
    className: 'status-transfer-rejected',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'status-transfer-cancelled',
  },
};

/**
 * @param {string} status
 * @param {'small'|'medium'} size — small for tables; medium for modals
 */
const TransferStatusBadge = ({ status = 'draft', size = 'small' }) => {
  const config = TRANSFER_STATUS_CONFIG[status] || {
    label: status || 'Unknown',
    className: 'status-transfer-cancelled',
  };
  const sizeClass = size === 'medium' ? 'status-pill-md' : 'status-pill-sm';

  return (
    <span
      className={`status-pill ${sizeClass} ${config.className}`}
      title={config.label}
    >
      {config.label.toUpperCase()}
    </span>
  );
};

export default TransferStatusBadge;
